import { useEffect } from 'react';
import { useUi } from '../stores/ui';

/** Événement émis pour ouvrir le compositeur (raccourcis « c » et « l »). */
export const COMPOSE_EVENT = 'keep:compose';
export type ComposeEventDetail = { type: 'text' | 'checklist' };

function isTyping(target: EventTarget | null) {
  return (
    target instanceof HTMLElement &&
    Boolean(target.closest('input, textarea, [contenteditable="true"]'))
  );
}

/** Raccourcis globaux de Keep : c (note), l (liste), Échap (désélectionner). « / » est géré par la recherche. */
export function useKeyboardShortcuts() {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.key === 'Escape') {
        useUi.getState().clearSelection();
        return;
      }
      if (isTyping(event.target) || document.querySelector('[role="dialog"]')) return;
      if (event.key === 'c' || event.key === 'l') {
        event.preventDefault();
        window.dispatchEvent(
          new CustomEvent<ComposeEventDetail>(COMPOSE_EVENT, {
            detail: { type: event.key === 'l' ? 'checklist' : 'text' },
          }),
        );
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
